/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '.././Order.sass';
import {
  addOrderAddress,
  updateOrderAddress,
  setIsValidOrder,
  setIsClickConfirmOrder,
  updateOrderDetailInfoAction,
} from '../../../actions/order';
import Order09PathComponent from './Order09PathComponent';
import Order09PathComponentWithMoreInfo from './Order09PathComponentWithMoreInfo';
import Order09PathComponentWithMoreInfoWithoutButton from './Order09PathComponentWithMoreInfoWithoutButton';
import { localStorageGet } from '../../../service/localStorage';
import imgAdd from '../../../assets/img/icon_add.png';
import imgAdd2 from '../../../assets/img/icon_add@2x.png';
import imgAddHover from '../../../assets/img/icon_add_hover.png';
import imgAddHover2 from '../../../assets/img/icon_add_hover@2x.png';

class Order09Path extends React.Component {
  static propTypes = {
    modelDataText: PropTypes.shape().isRequired,
    // modelData: PropTypes.shape().isRequired,
    address: PropTypes.arrayOf(
      PropTypes.shape({
        address: PropTypes.string,
        lat: PropTypes.number,
        lon: PropTypes.number,
      }),
    ).isRequired,
    lang: PropTypes.string.isRequired,
    addOrderAddress: PropTypes.func.isRequired,
    updateOrderAddress: PropTypes.func.isRequired,
    isClickConfirmOrder: PropTypes.bool.isRequired,
    setIsValidOrder: PropTypes.func.isRequired,
    // setIsClickConfirmOrder: PropTypes.func.isRequired,
    // order: PropTypes.shape().isRequired,
    updateOrderDetailInfoAction: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      addressComponent: [],
      addresses: localStorageGet('addresses', false),
      isValidAddress: true,
      scrollToComponent: null,
    };
    // this.onAddRoute = this.onAddRoute.bind(this);
    this.onAddRoute2 = this.onAddRoute2.bind(this);
    this.setScrollToComponent = this.setScrollToComponent.bind(this);
  }

  componentDidMount() {
    this.setScrollToComponent();
    // If no previous address data
    if (this.state.addresses === null) {
      for (let i = 0; i < 2; i += 1) {
        this.onAddRoute2(i);
      }
      // reuse the route or select places in quoting page
    } else if (
      this.props.address.length < this.state.addresses.waypoints.length
    ) {
      for (let i = 0; i < this.state.addresses.waypoints.length; i += 1) {
        this.onAddRoute2(i);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    // detect updated address
    if (nextProps.address !== this.props.address) {
      this.props.updateOrderDetailInfoAction(
        'waypoints_attributes',
        null,
        nextProps.address,
      );
    }
    if (nextProps.isClickConfirmOrder !== this.props.isClickConfirmOrder) {
      if (this.props.address.length > 1) {
        // check first 2 address
        if (
          this.props.address[0].address === '' ||
          this.props.address[1].address === ''
        ) {
          this.props.setIsValidOrder(false);
          this.setState({ isValidAddress: false });
          /* eslint-disable global-require */
          this.state.scrollToComponent(this.Order09PathComponent, {
            offset: -100,
            duration: 500,
          });
          // this.props.setIsClickConfirmOrder(false);
        } else {
          this.setState({ isValidAddress: true });
          // this.props.setIsClickConfirmOrder(false);
        }
      }
    }
  }

  onAddRoute2(i) {
    // init the address
    let address = {
      address: '',
      lat: 0,
      lon: 0,
    };
    this.props.addOrderAddress(address);
    if (
      this.state.addresses !== null &&
      typeof this.state.addresses.waypoints[i] !== 'undefined'
    ) {
      address = {
        address: this.state.addresses.waypoints[i].address,
        lat: this.state.addresses.waypoints[i].location.lat,
        lon: this.state.addresses.waypoints[i].location.lon,
      };

      this.props.updateOrderAddress(address, i);
    }

    let pathComponent = (
      <Order09PathComponent
        key={i}
        index={i}
        onSetActiveSuggestion={this.onSetActiveSuggestion}
        modelDataText={this.props.modelDataText}
      />
    );
    if (['tw', 'sg'].includes(this.props.lang)) {
      pathComponent = (
        <Order09PathComponentWithMoreInfo
          key={i}
          index={i}
          onSetActiveSuggestion={this.onSetActiveSuggestion}
          modelDataText={this.props.modelDataText}
        />
      );
    }
    if (this.props.lang === 'kr') {
      pathComponent = (
        <Order09PathComponentWithMoreInfoWithoutButton
          key={i}
          index={i}
          onSetActiveSuggestion={this.onSetActiveSuggestion}
          modelDataText={this.props.modelDataText}
        />
      );
    }
    this.state.addressComponent.push(pathComponent);
  }

  setScrollToComponent() {
    this.setState({ scrollToComponent: require('scroll-to-element') });
  }

  render() {
    return (
      <div
        ref={i => {
          this.Order09PathComponent = i;
        }}
      >
        <div className={s2.orderSmallTitle}>
          {this.props.modelDataText.order_summary_route_title}
        </div>

        {!this.state.isValidAddress ? (
          <p
            className={`${s.globalTextRed} ${s.globalFontNormal} ${
              s2.orderWarningText
            }`}
          >
            {this.props.modelDataText.order_route_input_warning}
          </p>
        ) : (
          ''
        )}

        {this.state.addressComponent}
        <span
          className={s2.orderFunctionText}
          role="button"
          tabIndex={0}
          onClick={() => {
            if (this.props.address.length < 9) {
              this.onAddRoute2(this.props.address.length);
            }
          }}
          onKeyPress={() => {}}
        >
          <img
            className={`${s2.orderFunctionIcon}`}
            data-hover="false"
            srcSet={`${imgAdd} 1x, ${imgAdd2} 2x`}
            height="18"
            alt=""
          />
          <img
            className={`${s2.orderFunctionIcon}`}
            data-hover="true"
            srcSet={`${imgAddHover} 1x, ${imgAddHover2} 2x`}
            height="18"
            alt=""
          />
          <span className={s2.addPathButton}>
            {this.props.modelDataText.order_option_route_add_address_button}
          </span>
        </span>
      </div>
    );
  }
}
const mapState = state => ({
  address: state.order.address,
  order: state.order,
  isClickConfirmOrder: state.order.isClickConfirmOrder,
});

const mapDispatch = {
  addOrderAddress,
  updateOrderAddress,
  setIsValidOrder,
  setIsClickConfirmOrder,
  updateOrderDetailInfoAction,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order09Path),
);



// WEBPACK FOOTER //
// ./src/routes/order/order09Path/Order09Path.js